import React from 'react';
import s from './TransparentSndButton.scss';

const TransparentSndButton = ({ onClick, type = "submit", delay, disabled, children, icon, name, style, car, className }) => (
    <div className={`${s.container} ${className}`}>
    <button onClick={onClick} type={type} name={name} disabled={disabled} className={(disabled) ? s.buttonGrey : s.uwButton} style={style}>
            {icon && <img className={(car) ? s.imgButtonCar : s.imgButton} src={icon} alt={"icono"} />} <p className={s.uwText} >{children}</p>
        </button>
    </div>
);

export default TransparentSndButton;
